import React from 'react';
import { motion } from 'framer-motion';
export function AchievementsSection() {
  const achievements = [{
    title: 'CLIENTES GLOBALES, PAGOS EN DÓLARES',
    description: 'Aprende a ofrecer los servicios digitales más demandados (redacción, traducciones, ideas para redes sociales). Clientes de cualquier parte del mundo te pagarán en moneda fuerte por un trabajo que la IA hará por ti en cuestión de minutos. Adiós a la devaluación.',
    image: 'https://cdn.shopify.com/s/files/1/0708/2174/0632/files/Gemini_Generated_Image_jbb4n7jbb4n7jbb4.jpg?v=1772301395',
    imageAlt: 'Persona cobrando en dólares online',
    align: 'left'
  }, {
    title: 'TU NEGOCIO 100% EN EL CELULAR',
    description: 'Derribamos el mito de la computadora costosa. Todo el sistema de este Masterkit está adaptado para que uses las versiones gratuitas de la Inteligencia Artificial directamente desde tu smartphone. Tu oficina ahora cabe en tu bolsillo.',
    image: 'https://cdn.shopify.com/s/files/1/0708/2174/0632/files/Gemini_Generated_Image_at9td1at9td1at9t.jpg?v=1772301395',
    imageAlt: 'Trabajando desde el celular inteligente',
    align: 'right'
  }, {
    title: 'LA REGLA DEL "COPIAR Y PEGAR"',
    description: '¿Cero experiencia previa? No hay problema. Te entregamos los comandos (prompts) exactos ya validados. Solo tienes que copiar, pegar en la IA y entregar un trabajo de nivel experto. Parecerás un genio tecnológico, aunque estés empezando desde cero.',
    image: 'https://cdn.shopify.com/s/files/1/0708/2174/0632/files/Gemini_Generated_Image_gbcrumgbcrumgbcr.jpg?v=1772301395',
    imageAlt: 'Sistema fácil de copiar y pegar con IA',
    align: 'left'
  }];
  return <section className="py-24 relative overflow-hidden bg-[#050505]" data-id="element-8">
      <div className="container mx-auto px-4" data-id="element-9">
        
        {/* NUEVO ENCABEZADO DE TRANSFORMACIÓN (ESTADO DESEADO) */}
        <div className="text-center mb-24 max-w-4xl mx-auto" data-id="element-10">
          <motion.div initial={{
          opacity: 0,
          y: -20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-cyan-500/10 border border-cyan-500/20 mb-6" data-id="element-11">
            <span className="w-2 h-2 rounded-full bg-cyan-400 animate-pulse" data-id="element-12"></span>
            <span className="text-sm font-bold text-cyan-400 tracking-wider" data-id="element-13">TU NUEVA REALIDAD</span>
          </motion.div>
          
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-5xl lg:text-6xl font-black text-white mb-6 tracking-tight leading-tight" data-id="element-14">
            TU VIDA <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500 drop-shadow-[0_0_15px_rgba(6,182,212,0.4)]" data-id="element-15">DESPUÉS DEL MASTERKIT</span>
          </motion.h2>
          
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-xl text-gray-400 font-light leading-relaxed max-w-2xl mx-auto" data-id="element-16">
            Esto es exactamente lo que vas a lograr cuando dejes de hacer las cosas manualmente y conviertas la Inteligencia Artificial en tu asistente personal.
          </motion.p>
        </div>

        {/* LISTA DE LOGROS */}
        <div className="space-y-28" data-id="element-17">
          {achievements.map((item, index) => <div key={index} className={`flex flex-col md:flex-row items-center gap-12 lg:gap-16 ${item.align === 'right' ? 'md:flex-row-reverse' : ''}`} data-id="element-18">
              {/* Image Side */}
              <motion.div initial={{
            opacity: 0,
            x: item.align === 'left' ? -60 : 60
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-80px'
          }} transition={{
            duration: 0.7,
            ease: 'easeOut'
          }} className="flex-1 w-full" data-id="element-19">
                <div className="relative rounded-2xl overflow-hidden border border-white/10 shadow-2xl shadow-cyan-500/10 group" data-id="element-20">
                  <img src={item.image} alt={item.imageAlt} className="w-full aspect-[4/3] object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-21" />
                  {/* Subtle gradient overlay to blend with page */}
                  <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-transparent pointer-events-none" data-id="element-22" />
                  {/* Glow behind image */}
                  <div className="absolute -inset-2 bg-cyan-500/10 blur-2xl -z-10 rounded-3xl group-hover:bg-cyan-500/20 transition-colors duration-500" data-id="element-23" />
                </div>
              </motion.div>

              {/* Text Side */}
              <motion.div initial={{
            opacity: 0,
            x: item.align === 'left' ? 60 : -60
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-80px'
          }} transition={{
            duration: 0.7,
            delay: 0.15,
            ease: 'easeOut'
          }} className="flex-1 text-center md:text-left relative" data-id="element-24">
                {/* Número de paso sutil de fondo */}
                <span className="absolute -top-10 -left-6 md:-left-10 text-[120px] font-black text-white/[0.03] -z-10 select-none" data-id="element-25">
                  0{index + 1}
                </span>

                <h3 className="text-3xl md:text-4xl font-black text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-300 mb-6 tracking-tight" data-id="element-26">
                  {item.title}
                </h3>
                <p className="text-lg md:text-xl text-gray-400 leading-relaxed font-light" data-id="element-27">
                  {item.description}
                </p>
              </motion.div>
            </div>)}
        </div>
      </div>
    </section>;
}